var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIconInboxNotif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99441 0.761141C7.92988 0.772447 7.68702 0.814527 7.45473 0.854591C4.1173 1.43035 1.32148 3.93253 0.363243 7.20132C0.298106 7.42354 0.199275 7.81648 0.143664 8.0745C0.0443165 8.53542 0.0422982 8.6299 0.0281258 13.4844L0.0136719 18.4253L0.338512 18.75L5.28104 18.7356C10.1372 18.7214 10.2317 18.7194 10.6928 18.6201C11.2937 18.4906 11.8756 18.3198 12.3287 18.1399C14.9602 17.0949 16.9688 14.8673 17.7246 12.1559C17.972 11.2684 18.0137 10.92 18.0137 9.7399C18.0137 8.55981 17.972 8.21139 17.7246 7.3239C16.8919 4.33659 14.5382 1.94986 11.5663 1.07926C10.687 0.821658 10.2926 0.768178 9.16762 0.753916C8.58688 0.746598 8.05893 0.749835 7.99441 0.761141ZM13.1844 7.57737C13.3318 7.64426 13.3946 7.70961 13.4539 7.85781C13.5257 8.0373 13.5257 8.06479 13.4539 8.24428C13.3946 8.39248 13.3318 8.45782 13.1844 8.52472C13.002 8.60752 12.7921 8.61193 9.02684 8.61193C5.26161 8.61193 5.05165 8.60752 4.86924 8.52472C4.72188 8.45782 4.65909 8.39248 4.59977 8.24428C4.52797 8.06479 4.52797 8.0373 4.59977 7.85781C4.65909 7.70961 4.72188 7.64426 4.86924 7.57737C5.05165 7.49457 5.26161 7.49016 9.02684 7.49016C12.7921 7.49016 13.002 7.49457 13.1844 7.57737ZM9.80557 10.9551C9.95293 11.022 10.0157 11.0873 10.075 11.2355C10.1468 11.415 10.1468 11.4425 10.075 11.622C10.0157 11.7702 9.95293 11.8355 9.80557 11.9024C9.62673 11.9836 9.45586 11.9896 7.33741 11.9896C5.21895 11.9896 5.04808 11.9836 4.86924 11.9024C4.72188 11.8355 4.65909 11.7702 4.59977 11.622C4.52797 11.4425 4.52797 11.415 4.59977 11.2355C4.65909 11.0873 4.72188 11.022 4.86924 10.9551C5.04808 10.8739 5.21895 10.8679 7.33741 10.8679C9.45586 10.8679 9.62673 10.8739 9.80557 10.9551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7",
    x: 12.0137,
    y: 0.25,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#FF007A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconInboxNotif);
export default __webpack_public_path__ + "static/media/chat-icon-inbox-notif.79cbbd112a63ac2511185d39e6eaa615.svg";
export { ForwardRef as ReactComponent };